// @flow
import {translate} from 'sulu-admin-bundle/utils/Translator';
import ResourceStore from 'sulu-admin-bundle/stores/ResourceStore';
import Router from 'sulu-admin-bundle/services/Router';
import {ResourceRequester} from 'sulu-admin-bundle/services';
import AbstractListToolbarAction from 'sulu-admin-bundle/views/List/toolbarActions/AbstractListToolbarAction';
import List from 'sulu-admin-bundle/views/List';
import {action, computed, IObservableValue, observable} from "mobx";
import {ListStore} from 'sulu-admin-bundle/containers';

export default class GenerateAiTexts extends AbstractListToolbarAction {
    @observable loading: boolean = false;
    listStore: ListStore;
    list: List;
    router: Router;
    locales: ?Array<string>;
    resourceStore: ?ResourceStore;
    options: {[key: string]: mixed};

    constructor(
        listStore: ListStore,
        list: List,
        router: Router,
        locales?: Array<string>,
        resourceStore?: ResourceStore,
        options: {[key: string]: mixed}
    ) {
        super(listStore, list, router, locales, resourceStore, options);
        this.listStore = listStore;
        this.list = list;
        this.router = router;
        this.locales = locales;
        this.resourceStore = resourceStore;
        this.options = options;
    }

    setLocales(locales: Array<string>) {
        this.locales = locales;
    }
    @computed get locale(): ?IObservableValue<string> {
        return this.resourceStore.locale;
    }

    @action handleDialogConfirm = () => {
        const {locale} = this.router.attributes;

        this.loading = true;
        const publishPromises = [];
        const queryOptions = {
            ...this.options,
            action: 'aiGenerate',
            locale: locale,
        }

        this.publishSelection = true;
        this.loading = true
        this.listStore.selectionIds.forEach((id) => {
            publishPromises.push(
                ResourceRequester.get("baseArticle", {...queryOptions, id: id})
                    .catch((error) => {
                        if (error.status !== 404) {
                            return Promise.reject(error);
                        }
                    })
            );
        });

        return Promise.all(publishPromises)
            .then(action(() => {
                this.listStore.clearSelection();
                this.listStore.reload();
                this.publishSelection = false;
                this.loading = false
            }))
            .catch(action((error) => {
                this.publishSelection = false;
                this.loading = false
                return Promise.reject(error);
            }));
    }

    getToolbarItemConfig() {
        const isDisabled = this.loading || this.listStore.selectionIds.length === 0;

        return {
            disabled: !!isDisabled,
            icon: 'su-inbox',
            label: translate('app.publish.marked_texts'),
            onClick: this.handleDialogConfirm,
            type: 'button',
        };
    }
}
